import React from 'react';
import { WizardContextType } from '../../types/Wizard';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const dummy = (): void => {};

const WizardContext = React.createContext<WizardContextType>({
  forSomeoneElse: false,
  promotions: false,
  setAppointmentType: dummy,
  setAppointmentTypeName: dummy,
  setCustomAppointmentType: dummy,
  setForSomeoneElse: dummy,
  setPersonalInformation: dummy,
  setPostAppointmentResponse: dummy,
  setPromotions: dummy,
  setSelfRating: dummy,
  setStep: dummy,
  setStore: dummy,
  setStoreSlot: dummy,
  step: 1,
});

export default WizardContext;
